export  function assertNever(value: never): never {
    throw new Error("Value supplied must be never. I received: " + value);
}
